import { render, staticRenderFns } from "./TicketExpenses.vue?vue&type=template&id=6d41caba&"
import script from "./TicketExpenses.vue?vue&type=script&lang=js&"
export * from "./TicketExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports